import styled from "styled-components";

export default styled.img`
  object-fit: contain;
  width: 229px;
  height: 227px;
  margin: 0;
  grid-area: img;
`;
